import React, {useEffect} from 'react'
import PublishFormItem from "./body/PublishFormItem"
import {CONNECTED, DRAFT, PROTECT, PUBLISH, VisibilityTypes} from "../../../constants/visibility"
import {
  changeAcceptComment,
  changeDaumLikeCategory, changePostPassword,
  changePublished,
  changeSlogan, changeThumbnail,
  changeVisibility,
  changeGoogleRecaptchaValue,
} from "../../../actions/post"
import {useDispatch, useSelector} from "react-redux"
import {adjustVisibility, getThumbnailFromContent, selectPostCategoryVisibility, canUseVisibility} from "../../../lib/PostUtils"
import VisibilityButton from "./body/VisibilityButton"
import SelectMenuButton from "./body/SelectMenuButton"
import classnames from "classnames"
import dateFormat from "dateformat"
import PostType from '../../../constants/PostType'
import DateForm from "./body/DateForm"
import {attachFile} from "../../../lib/Uploader"
import AttachmentUrlConverter from "../../../lib/attachment/AttachmentUrlConverter"
import ThumbnailFarm from "../../../lib/attachment/ThumbnailFarm"
import ReCAPTCHA from "react-google-recaptcha";


function makeAvailableTypes() {
  const isPost = PostType.isPost(Config.postType)
  const isTistoryService = appInfo.service === 'tistory'

  return VisibilityTypes.filter(item => {
    if (isPost) {
      if (isTistoryService) {
        return item.value !== CONNECTED
      } else {
        return item.value !== PROTECT
      }
    } else {
      return item.value !== CONNECTED && item.value !== PROTECT
    }
  })
}

function VisibilityButtons({ blogVisibility, postCategoryVisibility, visibility, onChange }) {
  const availableTypes = makeAvailableTypes()
  return availableTypes.map((item) => {
    const disabled = !canUseVisibility(blogVisibility, postCategoryVisibility, item.value);
    return <VisibilityButton
            key={item.value}
            visibility={item}
            selected={Math.abs(visibility) == item.value}
            disabled={disabled}
            onChange={() => onChange(item.value)}
          />
    }
  )
}

function AcceptComment({ value, onChange }) {
  if (!PostType.isPost(Config.postType)) {
    return null
  }

  return (
    <SelectMenuButton
      menus={[
        {value: 1, label: '댓글 허용'},
        {value: 0, label: '댓글 비허용'},
      ]}
      value={value}
      onSelect={onChange}
      width={'130px'}
    />
  )
}

function PostStatus() {

  const post = useSelector(state => state.post.newPost)
  const postCategoryVisibility = useSelector(state => selectPostCategoryVisibility(state.post.newPost, state.blog.categories))
  const blogVisibility = useSelector(state => state.blog.visibility);

  const dispatch = useDispatch()

  function handleChangeVisibility(visibility) {
    dispatch(changeVisibility(visibility))
  }
  function handleChangeAcceptComment(acceptComment) {
    dispatch(changeAcceptComment(acceptComment))
  }

  return (
    <PublishFormItem title={'기본'}>
      <VisibilityButtons
        blogVisibility={blogVisibility}
        postCategoryVisibility={postCategoryVisibility}
        visibility={post.visibility}
        onChange={handleChangeVisibility}
      />
      <AcceptComment
        value={post.acceptComment}
        onChange={handleChangeAcceptComment}
      />
    </PublishFormItem>
  )
}

function DaumLikeCategory() {
  const post = useSelector(state => state.post.newPost)
  const dispatch = useDispatch()

  if (!PostType.isPost(Config.postType)) {
    return null
  }

  if (post.visibility == PROTECT) {
    return null
  }

  function handleChangeDaumLikeCategory(daumCategory) {
    dispatch(changeDaumLikeCategory(daumCategory))
  }

  const daumLikeCategory= post.daumLikeCategory
  const disabled = post.visibility != PUBLISH

  return (
    <PublishFormItem title={'홈주제'} className={classnames({'disabled':disabled, 'selected':!!daumLikeCategory})}>
      <SelectMenuButton
        menus={[
          {value: 0, label: '선택 안 함'}
        ].concat(window.daumLikeCategories)}
        value={daumLikeCategory}
        disabled={disabled}
        onSelect={handleChangeDaumLikeCategory}
        width={'150px'}
      />
    </PublishFormItem>
  )
}

function ProtectPassword() {
  const post = useSelector(state => state.post.newPost)
  const dispatch = useDispatch()

  function handleChangePostPassword(password) {
    dispatch(changePostPassword(password))
  }

  if (!PostType.isPost(Config.postType)) {
    return null
  }

  if (post.visibility != PROTECT) {
    return null
  }

  return (
    <PublishFormItem title={'비밀번호'}>
      <div className="tf_g">
        <input
          type="text" name='postPassword' id='postPassword'
          className="inp_g" title="보호 비밀번호" defaultValue={post.password}
          onChange={e => handleChangePostPassword(e.target.value)}
        />
      </div>
    </PublishFormItem>
  )
}

function PublishedButton({on, onClick, text, disabled}) {
  return (
    <button type="button" className={classnames("btn_date", {"on": on})} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  )
}

function PostPublished() {
  const post = useSelector(state => state.post.newPost)
  const postCategoryVisibility = useSelector(state => selectPostCategoryVisibility(state.post.newPost, state.blog.categories))
  const orgPost = useSelector(state => state.post.orgPost)
  const dispatch = useDispatch()

  if (!PostType.isPost(Config.postType)) {
    return null
  }

  function handleChangePublished(published) {
    dispatch(changePublished(published))
  }

  const visibility = adjustVisibility(post.visibility, postCategoryVisibility);

  return (
    <PublishFormItem title={'발행일'} className={visibility === DRAFT? 'disabled':''}>
      {!orgPost.published && post.orgPublished &&
        <PublishedButton
          on={post.published == 0}
          onClick={() => handleChangePublished(0)}
          text={dateFormat(new Date(post.orgPublished * 1000), 'yyyy-mm-dd HH:MM')}
          disabled={visibility === DRAFT}
        />
      }

      {visibility !== DRAFT &&
        <PublishedButton
          on={post.published == 1}
          onClick={() => handleChangePublished(1)}
          text='현재'
        />
      }

      {visibility !== DRAFT &&
        <PublishedButton
          on={post.published > 1}
          onClick={() => handleChangePublished(parseInt(new Date().getTime() / 1000) + 3600)}
          text='예약'
        />
      }

      {visibility !== DRAFT && post.published > 1 &&
        <DateForm published={post.published} onChange={handleChangePublished} />
      }
    </PublishFormItem>
  )
}

function PostSlogan() {
  const blogDomain = useSelector(state => state.blog.domain)
  const slogan = useSelector(state => state.post.newPost.slogan)
  const dispatch = useDispatch()
  const isPageType = PostType.isPage(Config.postType)
  const isPostType = PostType.isPost(Config.postType)

  function handleChangeSlogan(slogan) {
    dispatch(changeSlogan(slogan))
  }

  if ((!isPostType || appInfo.service === 'blog') && !isPageType) {
    return null
  }

  const useSlogan = isPageType || Config.blog.blogSettings.useSlogan == '1'
  const prefix = isPageType? 'pages' : 'entry'
  return (
    <PublishFormItem title={'URL'} className={!useSlogan? 'disabled':''}>
      <span className="txt_g">{blogDomain}/{prefix}/</span>
      <div className="tf_g">
        <input
          type="text" name="urlPublish" id="urlPublish" disabled={!useSlogan}
          className="inp_g" title="발행 URL" defaultValue={slogan}
          onChange={e => handleChangeSlogan(e.target.value)}
        />
      </div>
    </PublishFormItem>
  )
}

function PostThumbnail() {
  const thumbnail = useSelector(state => state.post.newPost.thumbnail)
  const dispatch = useDispatch()

  function handleChangeThumbnail(newThumbnail) {
    dispatch(changeThumbnail(newThumbnail))
  }

  function handleAttachThumbnail(e) {
    if (e.target.files && e.target.files.length === 0) {
      return;
    }

    const file = e.target.files[0];
    attachFile(file)
      .then(data => handleChangeThumbnail(`kage@${data.key}/${data.filename}`))
      .catch(e => {
        alert('대표이미지를 업로드하는데 실패했습니다.');
      })
  }

  return (
    <div className="box_thumb">
      {thumbnail &&
      <div className="inner_box">
          <span className="thumb_g" style={{backgroundImage:`url(${ThumbnailFarm.to('C170x170', AttachmentUrlConverter.toUrl(thumbnail))})`}}>
            <button type="button" className="mce-ico ico_delete" onClick={e => handleChangeThumbnail(null)}>삭제</button>
          </span>
      </div>
      }
      {!thumbnail &&
      <div className="inner_box">
        <input type="file" accept='image/*' className="inp_g" onChange={handleAttachThumbnail} />
        <i className="mce-ico ico_attach" />
        <span className="txt_thumb">대표이미지 추가</span>
      </div>
      }
    </div>
  )
}

function GoogleRecaptcha() {

  const dispatch = useDispatch()

  function handleChangeRecaptchaValue(value) {
    dispatch(changeGoogleRecaptchaValue(value))
  }

  function handleExpiredRecaptchaValue() {
    dispatch(changeGoogleRecaptchaValue(''))
  }

  function handleErroredRecaptchaValue() {
    dispatch(changeGoogleRecaptchaValue(''))
  }

  return (
    <dl className={`info_editor googleRecaptcha`}>
      <ReCAPTCHA
          sitekey="6LeUPDEUAAAAAN-sxDuqig_KBf8656nNinj4WzKb"
          onChange={handleChangeRecaptchaValue}
          onExpired={handleExpiredRecaptchaValue}
          onErrored={handleErroredRecaptchaValue}
        />
    </dl>
  )
}


export default function PublishLayerBody() {

  const post = useSelector(state => state.post.newPost)
  const postCategoryVisibility = useSelector(state => selectPostCategoryVisibility(state.post.newPost, state.blog.categories))
  const blogVisibility = useSelector(state => state.blog.visibility);
  const initVisibility = Math.min(blogVisibility, adjustVisibility(post.visibility, postCategoryVisibility));
  const dispatch = useDispatch()
  const needCaptcha = useSelector(state => state.post.needCaptcha);

  useEffect(() => {
    dispatch(changeThumbnail(post.thumbnail? post.thumbnail : getThumbnailFromContent(post.content)))
    dispatch(changeVisibility(initVisibility))
  }, [])

  return(
    <div className="layer_body">
      <div className="publish_editor">
        <strong className="tit_publish">{post.title}</strong>

        <PostStatus />
        <DaumLikeCategory />
        <ProtectPassword />
        <PostPublished />
        <PostSlogan />

        <PostThumbnail />
        { needCaptcha && <GoogleRecaptcha /> }
      </div>
    </div>
  )
}
